import React, { useState } from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import varifiedIcon from "../../../assests/verifiedIcon.svg";
import './SubCategoryForm.css';

const SubCategoryEditComponent = ({
  formData,
  imagePreview,
  isSubmitting,
  isFormValid,
  category,
  subCategory,
  onChange,
  onStatusChange,
  onImageChange,
  onSubmit,
  onBack,
  fileInputRef,
  showSuccessPopup,
  onSuccessClose,
  categoryName,
}) => {
  const [dragActive, setDragActive] = useState(false);

  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    const file = e.dataTransfer.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleRemoveImage = (e) => {
    e.stopPropagation();
    onImageChange(null);
  };

  const getParentCategoryName = () => {
    if (category) {
      return category.name || category.categoryName || categoryName;
    }
    return categoryName || "";
  };

  return (
    <div className="subcategory-edit-container">
      <Sidebar />
      
      {isSubmitting && (
        <div className="subcategory-edit-full-loader">
          <div className="spinner"></div>
        </div>
      )}
      
      <div className="subcategory-edit-content">
        <div className="subcategory-edit-header">
          <button className="subcategory-edit-back-btn" onClick={onBack}>
            ←
          </button>
          <h1>Edit Sub Category</h1>
          <div className="subcategory-edit-parent-info">
            <span className="subcategory-edit-parent-label">Parent Category:</span>
            <span className="subcategory-edit-parent-name">{getParentCategoryName() || "Loading..."}</span>
          </div>
        </div>

        <div className="subcategory-edit-wrapper">
          <div className="subcategory-edit-card">
            <form onSubmit={onSubmit}>
              {/* Sub Category Name Field */}
              <div className="subcategory-edit-group">
                <label className="subcategory-edit-label">
                  Sub Category Name <span className="subcategory-edit-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={onChange}
                  placeholder="Eg. Wireless Headphones, Smartphones"
                  className="subcategory-edit-input"
                />
              </div>

              {/* Description Field */}
              <div className="subcategory-edit-group">
                <label className="subcategory-edit-label">Description (Optional)</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={onChange}
                  placeholder="Brief summary of sub-category"
                  className="subcategory-edit-textarea"
                  rows="3"
                />
              </div>

              {/* Status Field */}
              <div className="subcategory-edit-group">
                <label className="subcategory-edit-label">Status</label>
                <div className="subcategory-edit-status-buttons">
                  <button
                    type="button"
                    className={`subcategory-edit-status-btn ${formData.status === 'active' ? 'subcategory-edit-status-active' : ''}`}
                    onClick={() => onStatusChange('active')}
                  >
                    Active
                  </button>
                  <button
                    type="button"
                    className={`subcategory-edit-status-btn ${formData.status === 'inactive' ? 'subcategory-edit-status-inactive' : ''}`}
                    onClick={() => onStatusChange('inactive')}
                  >
                    Inactive
                  </button>
                </div>
              </div>

              {/* Image Upload Field */}
              <div className="subcategory-edit-group">
                <label className="subcategory-edit-label">Image</label>
                <div 
                  className={`subcategory-edit-upload-area ${dragActive ? 'subcategory-edit-drag-active' : ''}`}
                  onClick={() => fileInputRef.current?.click()}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={handleImageSelect}
                  />
                  {imagePreview ? (
                    <div className="subcategory-edit-preview-container">
                      <img src={imagePreview} alt="Preview" className="subcategory-edit-preview" />
                      <button 
                        type="button"
                        className="subcategory-edit-remove-btn"
                        onClick={handleRemoveImage}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className="subcategory-edit-upload-placeholder">
                      <div className="subcategory-edit-upload-icon">📤</div>
                      <p className="subcategory-edit-upload-text">
                        <span className="subcategory-edit-browse-link">Choose file</span> or drag here
                      </p>
                      <p className="subcategory-edit-upload-hint">Png, Jpg, up to 5MB</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="subcategory-edit-actions">
                <button 
                  type="button" 
                  className="subcategory-edit-cancel-btn"
                  onClick={onBack}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className={`subcategory-edit-submit-btn ${isFormValid ? 'subcategory-edit-active' : 'subcategory-edit-disabled'}`}
                  disabled={!isFormValid || isSubmitting}
                >
                  {isSubmitting ? 'Updating...' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="subcategory-edit-success-overlay">
          <div className="subcategory-edit-success-modal">
            <div className="subcategory-edit-success-icon">
              <img style={{width:"100%", height:"100%"}} src={varifiedIcon} alt="success" />
            </div>
            <h3 className="subcategory-edit-success-title">Updated Successfully!</h3>
            <p className="subcategory-edit-success-message">Sub category has been updated successfully.</p>
            
            <div className="subcategory-edit-success-details">
              <div className="subcategory-edit-success-row">
                <span className="subcategory-edit-success-label">Name:</span>
                <span className="subcategory-edit-success-value">{formData.name}</span>
              </div>
              <div className="subcategory-edit-success-row">
                <span className="subcategory-edit-success-label">Parent Category:</span>
                <span className="subcategory-edit-success-value">{getParentCategoryName()}</span>
              </div>
            </div>
            
            <button 
              className="subcategory-edit-success-btn" 
              onClick={onSuccessClose}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubCategoryEditComponent;